import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { settingsApi } from '../../services/api'
import { useLanguage } from '../../context/LanguageContext'
import { parseSettingsResponse } from '../../utils/settings'
import { SOCIAL_LINKS, WhatsAppIcon } from '../../constants/social'

export default function WhatsAppFloatButton() {
  const { t } = useTranslation()
  const { language } = useLanguage()
  const [whatsappUrl, setWhatsappUrl] = useState(SOCIAL_LINKS.whatsapp)

  useEffect(() => {
    settingsApi
      .get()
      .then(({ data }) => {
        const settings = parseSettingsResponse(data, language)
        if (settings.whatsapp) {
          setWhatsappUrl(settings.whatsapp)
        }
      })
      .catch(() => {})
  }, [language])

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('buttons.chatWhatsApp')}
      className="fixed bottom-[max(1.25rem,env(safe-area-inset-bottom))] end-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/40 transition-transform hover:scale-105 hover:bg-[#20BD5A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#25D366] sm:bottom-6 sm:end-6 sm:h-[3.75rem] sm:w-[3.75rem]"
    >
      <WhatsAppIcon className="h-7 w-7 fill-current sm:h-8 sm:w-8" />
    </a>
  )
}
